/**
 * Compte bêta DÉSIGNÉ (03/10/2026) : compte de démonstration partagé entre
 * plusieurs testeurs. Ce qui ferait perdre la main sur le compte est grisé —
 * et refusé par l'API (`beta_compte_verrouille`), le grisé n'étant qu'un
 * confort.
 */
export const TITRE_VERROU_BETA = 'Désactivé : compte de démonstration partagé (version bêta)';

export function CompteBetaAvis() {
  return (
    <div className="avis-beta" role="note">
      <strong>Compte de démonstration partagé</strong>
      <span>
        Ce compte sert aux tests de la version bêta et peut être utilisé par plusieurs personnes. La
        double authentification, les moyens de connexion, les membres et invitations de l’espace,
        l’abonnement et la suppression du compte sont désactivés.
      </span>
    </div>
  );
}
